var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Add Categorized Estimator")]),_c('button',{staticClass:"closeIcon",staticStyle:{"width":"40px","height":"40px"},on:{"click":_vm.closeModal}},[_c('span')])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Here you can add a categorized estimator.")])])
}]

export { render, staticRenderFns }